const Lang = require('lang');
const template = require('lodash/template')
const GlobalAlerts = require('../../../../functions/GlobalAlerts');
const templateTagWord = template(require('../../../../templates/tags/word.html'));
const templateGroupTagWord = template(require('../../../../templates/tags/word-group.html'));

/**
 * Inicializador
 */
function TagEdit() {
  const buttonFormSubmit = document.querySelector('[data-tag-form-submit]');
  buttonFormSubmit.addEventListener('click', handlerSubmitForm);

  applyListenersAddWords();
}

/**
 * Listeners de Adição de Palavras
 */
function applyListenersAddWords() {
  const formAddWord = document.querySelector('.add-word__wrapper');
  const buttonShowAddWord = document.querySelector('[data-word-add-show]');
  const buttonsRemoveWord = document.querySelectorAll('[data-word-delete]');
  const buttonSubmitAddWord = document.querySelector('[data-word-add-submit]');

  if (buttonsRemoveWord.length) {
    buttonsRemoveWord.forEach((currentButton) => {
      currentButton.addEventListener('click', handlerRemoveWord);
    });
  }

  buttonSubmitAddWord.addEventListener('click', handlerSubmitAddWord);

  buttonShowAddWord.addEventListener('click', handlerClickShowFormAddWord);

  formAddWord.addEventListener('submit', (event) => {
    event.preventDefault();
    handlerSubmitAddWord(event);
  });
}

/**
 * Manipulador do envio atualização da tag
 *
 * Atualização dos atributos principais da tag,
 * nome e tipo por exemplo
 *
 * @param {EVent} event
 */
function handlerSubmitForm(event) {
  const submitButton = event.target;
  const form = submitButton.closest('form');

  const url = route('app.settings.horus.tags.atualizar', {
    idTag: submitButton.dataset.tagId
  });
  const data = {
    tag:  form.querySelector('[name="tag"]').value
  }

  if (!$(form).valid()) {
    return;
  }

  submitButton.disabled = true;

  sendRequest(data, 'PUT', url)
    .done((response) => {
      document
        .querySelector('[data-tag-name]')
        .textContent = data.tag;

      GlobalAlerts.createAndShow({
        type: 'success',
        title: Lang.get('js/common/phrases.success'),
        message: response.message
      });
    })
    .fail(() => {
      GlobalAlerts.createAndShow({
        type: 'danger',
        title: Lang.get('js/common/phrases.ops'),
        message: Lang.get('js/common/phrases.unexpected_error')
      });
    })
    .always(() => submitButton.disabled = false);
}

/**
 * Manipulador exibir formulário adicionar palavra
 *
 * Irá exibir ou ocultar o formulário de adição de palavras
 */
function handlerClickShowFormAddWord() {
  const openedClass = 'add-word__wrapper--opened';
  const wrapperAddWord = document.querySelector('.add-word__wrapper')

  wrapperAddWord.classList.toggle(openedClass);
}

/**
 * Manipulador adicionar palavra
 *
 * Desabilita o botão de submit e dispara a request ao servdor
 * para salvar a palavra, no caso de sucesso renderiza a palavra
 * e limpa a input do formulário.
 * No caso de falha exibe o alerta para o usuário, em ambos os casos
 * o botão de submit é reabilitado
 *
 * @param {Event} event
 */
function handlerSubmitAddWord(event) {
  const submitButton = event.target;
  const form =  submitButton.closest('form');
  const inputWord = form.querySelector('input[name=word]');

  const word = inputWord.value;
  const idTag = form.dataset.wordTagId;

  const url = route('app.settings.horus.tags.adicionar-palavra', {
    idTag: idTag
  });
  const data = {
    word,
    list: 'whitelist'
  };

  if (!$(form).valid()) {
    return;
  }

  if (form.classList.contains('add-word__wrapper--disabled')) {
    return;
  }

  submitButton.disabled = true;
  form.classList.toggle('add-word__wrapper--disabled');

  sendRequest(data, 'POST', url)
    .done(() => {
      renderNewWord(word, idTag);
      inputWord.value = '';
    })
    .fail(() => {
      GlobalAlerts.createAndShow({
        type: 'danger',
        title: Lang.get('js/common/phrases.ops'),
        message: Lang.get('js/common/phrases.unexpected_error')
      });
    })
    .always(() =>  {
      submitButton.disabled = false
      form.classList.toggle('add-word__wrapper--disabled');
    });
}

/**
 * Manipulador de remover palavra
 *
 * Desabilita o click no botão de remover e aplica classe de
 * estilo de botão sendo removido, envia a request para o servidor
 * e no caso de sucesso manipula a exclusão do item da tela.
 * No caso de falha a classe de removendo será removida da palavra
 * e o botão de remvoer reabilitado
 *
 * @param {Event} event
 */
function handlerRemoveWord(event) {
  const buttonRemove = event.target;
  const wordElement = buttonRemove.closest('.word__wrapper');

  const url = route('app.settings.horus.tags.remover-palavra', {
    idTag: buttonRemove.dataset.wordTagId
  });

  const data = {
    word: buttonRemove.dataset.wordDelete,
    list: buttonRemove.dataset.wordList
  };

  buttonRemove.disabled = true;
  wordElement.classList.add('word__wrapper--removing');

  sendRequest(data, 'DELETE', url)
    .done(() => {
      renderRemoveWord(wordElement, data.word);
    })
    .fail(() => {
      buttonRemove.disabled = false;
      wordElement.classList.toggle('tag-word__wrapper--removing');

      GlobalAlerts.createAndShow({
        type: 'danger',
        title: Lang.get('js/common/phrases.ops'),
        message: Lang.get('js/common/phrases.unexpected_error')
      });
    });
}

/**
 * Renderizar na tela a palavra que foi adicionada
 * a tag
 *
 * @param {string} word
 * @param {string} idTag
 */
function renderNewWord(word, idTag) {
  word = word.toUpperCase();
  const keyWord = word.charAt(0);

  // Adicionar elemento que agrupa as palavras
  // se for necessário
  addGroupWords(keyWord);

  // Adicionar a palavra na view
  addWord(word, idTag, keyWord);

  // Aplicar o listener do botão de delete
  // da palavra
  document
    .querySelector(`[data-word-delete="${word}"]`)
    .addEventListener('click', handlerRemoveWord);

  // Removendo a mensagem de alerta que informa não
  // ter palavras cadastradas
  toggleShowAlertNoneWords();
}

/**
 * Adiciona um agrupador de palavras
 *
 * o agrupador será adicionado em ordem alfabética e apenas
 * se for necessário se não existir uma agrupador dele
 *
 * @param {string} keyWord
 */
function addGroupWords(keyWord) {
  const wordsWrapper = document.querySelector('[data-word-wrapper]');
  const keyWordsWrapper = document.querySelector(`[data-word-key="${keyWord}"]`);
  const listKeys = JSON.parse(wordsWrapper.dataset.wordKeys);

  if (keyWordsWrapper !== null) {
    return;
  }

  const newKeyWordWrapper = templateGroupTagWord({
    key: keyWord,
    added: true
  });

  listKeys.push(keyWord);
  listKeys.sort();

  const nextKey = listKeys[listKeys.indexOf(keyWord) + 1];

  if (nextKey === undefined) {
    $(wordsWrapper).append(newKeyWordWrapper);
  } else {
    $(newKeyWordWrapper).insertBefore(`[data-word-key="${nextKey}"]`);
  }

  wordsWrapper.dataset.wordKeys = JSON.stringify(listKeys);
}

/**
 * Adiciona uma palavra
 *
 * A palavra será adicionada em ordem alfabética dentro do
 * agrupador que ela faz parte
 *
 * @param {string} word
 * @param {string} idTag
 * @param {string} keyWord
 */
function addWord(word, idTag, keyWord) {
  const newWord = templateTagWord({
    word,
    idTag,
    added: true
  });

  const wordsWrapper = document
    .querySelector(`[data-word-key="${keyWord}"] .panel-body`);

  const listWords = JSON.parse(wordsWrapper.dataset.wordItems);

  listWords.push(word);
  listWords.sort();

  const nextWord = listWords[listWords.indexOf(word) + 1];

  if (nextWord === undefined) {
    $(wordsWrapper).append(newWord);
  } else {
    $(newWord).insertBefore(`[data-word-value="${nextWord}"]`);
  }

  wordsWrapper.dataset.wordItems = JSON.stringify(listWords);
}

/**
 * Remover a palavra da view
 *
 * Quando a palavra for removida a lista de palavras dentro do
 * conteúdo do painel também será atualizada para o conteúdo atual.
 * Caso não permaneça nenhum palavra no painel que agrupa as palavras
 * pela letra inicial, este painel será removido e a palavra inicial
 * removida da lista de chaves dentro da página
 *
 * @param {Element} wordElement
 * @param {string} word
 */
function renderRemoveWord(wordElement, word) {
  const panelsWrapper = wordElement.closest('[data-word-keys]');
  const panelWord = wordElement.closest('[data-word-key]');
  const panelWordContent = wordElement.closest('[data-word-items]');

  const wordKey = panelWord.dataset.wordKey.charAt(0);
  let listKeysPanels = JSON.parse(panelsWrapper.dataset.wordKeys);
  let listWordsInWrapper = JSON.parse(panelWordContent.dataset.wordItems);

  wordElement.remove();

  listWordsInWrapper = listWordsInWrapper.filter((currentWord) => {
    return currentWord !== word;
  });

  panelWordContent.dataset.wordItems = JSON.stringify(listWordsInWrapper);

  if (!listWordsInWrapper.length) {
    panelWord.remove();

    listKeysPanels = listKeysPanels.filter((currentKey) => {
      return currentKey !== wordKey;
    });

    panelsWrapper.dataset.wordKeys = JSON.stringify(listKeysPanels);
  }

  toggleShowAlertNoneWords();
}

/**
 * Alerta de SEM palavras
 *
 * Irá exbir o alerta de sem palavras que nenhuma
 * estiver disponível na tela, ou irá ocultá-lo quando
 * palavras tiverem sidos adicionadas
 */
function toggleShowAlertNoneWords() {
  const wrapperKeyWords = document
    .querySelector('[data-word-keys]')
    .getAttribute('data-word-keys');

  const alertElement = document
    .querySelector('[data-word-alert]');

  const listKeyWord = JSON.parse(wrapperKeyWords);

  if (!listKeyWord.length) {
    alertElement.classList.remove('hidden');

    return;
  }

  alertElement.classList.add('hidden');
}

/**
 * Enviar a request para o servidor
 *
 * @param {Object} data
 * @param {string} method
 * @param {string} url
 */
function sendRequest(data, method, url) {
  return $.ajax({
    url,
    method: method.toUpperCase(),
    data
  });
}

module.exports = {
  init: TagEdit,
  url: /^\/settings\/horus\/tags\/editar/,
}
